module.exports = __webpack_public_path__ + "static/media/mariposa-01.8c5a9fe7.jpg";